import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Row, Col, Badge } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiUserPlus,
} from "react-icons/fi";

const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();


const Usuarios = () => {
  const id_Usuario = cookies.get("id_Usuario");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    nombre_Completo: "",
    correoElectronico: "",
    contraseña: "",
    estado: true,
  });

  const [editingId, setEditingId] = useState(null);
  const itemsPerPageOptions = [5, 10, 20, 50];

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const fetchData = async () => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/usuarios`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
      });
      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "No se pudieron cargar los usuarios", "error");
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        item.nombre_Completo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.correoElectronico.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const validateForm = () => {
    const newErrors = {};

    if (
      !formData.nombre_Completo ||
      formData.nombre_Completo.length < 3 ||
      formData.nombre_Completo.length > 100
    ) {
      newErrors.nombre_Completo =
        "El nombre debe tener entre 3 y 100 caracteres";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      !formData.correoElectronico ||
      !emailRegex.test(formData.correoElectronico)
    ) {
      newErrors.correoElectronico = "Ingrese un correo electrónico válido";
    }

    if (
      !editingId &&
      (!formData.contraseña || formData.contraseña.length < 6)
    ) {
      newErrors.contraseña = "La contraseña debe tener al menos 6 caracteres";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      const { id_Usuario, createdAt, updatedAt, ...filteredItem } = item;
      setFormData(filteredItem);
      setEditingId(item.id_Usuario);
    } else {
      setFormData({
        nombre_Completo: "",
        correoElectronico: "",
        contraseña: "",
        estado: true,
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const handleSubmit = async () => {
    const bearertoken = cookies.get("token");
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/usuarios/${editingId}` : "/usuarios";
    const dataToSubmit = { ...formData };

    try {
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId
          ? "Usuario actualizado correctamente"
          : "Usuario creado correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema en la operación",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/usuarios/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("Eliminado!", "El usuario ha sido eliminado.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el usuario", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Usuarios</h5>
            <Button
              variant='success'
              onClick={() => handleShowModal()}
              size='sm'
              className='d-flex align-items-center gap-2'
            >
              <FiUserPlus size={18} />
              <span>Agregar Nuevo</span>
            </Button>
          </div>

          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por nombre o correo...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Nombre Completo</th>
                  <th className='border-top-0'>Correo Electrónico</th>
                  <th className='border-top-0'>Estado</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.id_Usuario}>
                    <td className='text-muted'>{item.id_Usuario}</td>
                    <td>{item.nombre_Completo}</td>
                    <td>{item.correoElectronico}</td>
                    <td>
                      <Badge bg={item.estado ? "success" : "secondary"}>
                        {item.estado ? "Activo" : "Inactivo"}
                      </Badge>
                    </td>
                    <td className='text-end'>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        className='me-2'
                        title='Ver'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.id_Usuario)}
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Agregar"} Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Nombre Completo
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='nombre_Completo'
                    value={formData.nombre_Completo}
                    onChange={handleChange}
                    isInvalid={!!errors.nombre_Completo}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.nombre_Completo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Correo Electrónico
                  </Form.Label>
                  <Form.Control
                    type='email'
                    name='correoElectronico'
                    value={formData.correoElectronico}
                    onChange={handleChange}
                    isInvalid={!!errors.correoElectronico}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.correoElectronico}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    {!editingId && <span className='text-danger'>*</span>}{" "}
                    Contraseña
                    {editingId && (
                      <small className='text-muted ms-2'>
                        (Dejar en blanco para no cambiar)
                      </small>
                    )}
                  </Form.Label>
                  <Form.Control
                    type='password'
                    name='contraseña'
                    value={formData.contraseña}
                    onChange={handleChange}
                    isInvalid={!!errors.contraseña}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.contraseña}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Estado</Form.Label>
                  <Form.Select
                    name='estado'
                    value={formData.estado}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        estado: e.target.value === "true",
                      })
                    }
                    className='border'
                  >
                    <option value={true}>Activo</option>
                    <option value={false}>Inactivo</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles del Usuario
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>ID:</span>{" "}
                    {selectedItem.id_Usuario}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Nombre:</span>{" "}
                    {selectedItem.nombre_Completo}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Correo:</span>{" "}
                    {selectedItem.correoElectronico}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Estado:</span>
                    <Badge
                      bg={selectedItem.estado ? "success" : "secondary"}
                      className='ms-2'
                    >
                      {selectedItem.estado ? "Activo" : "Inactivo"}
                    </Badge>
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Registro</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Creado:</span>{" "}
                    {formatDate(selectedItem.createdAt)}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Actualizado:</span>{" "}
                    {formatDate(selectedItem.updatedAt)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Usuarios;
